import React, { useEffect, useState } from 'react';
import Achievements from '../AboutUs/Achievements';
import SisterConcerms from '../AboutUs/SisterConcerms';
import AboutBanner from '../AboutUs/AboutBanner';
import WhyChooseUsSection from './../../components/WhyChooseUs/WhyChooseUs';

import {
  FaLayerGroup,
  FaUserAstronaut,
  FaChess,
  FaUserTie,
  FaShieldAlt,
  FaLightbulb,
  FaChartLine,
  FaHandshake,
  FaGlobeAsia,
  FaCheckCircle
} from 'react-icons/fa';

// ১. বিস্তারিত ৯টি ফিচার কার্ডের ডেটা
const whyChooseUsData = [
  {
    icon: <FaLayerGroup />,
    title: "Diversified Business Platform",
    description: "We operate across multiple industries, creating opportunities for collaboration, resource sharing, and sustainable business growth under one unified corporate platform.",
    highlight: "Cross-industry Synergy",
    themeColor: "#00afe9"
  },
  {
    icon: <FaUserAstronaut />,
    title: "Entrepreneur-Centric Approach",
    description: "We believe great businesses begin with visionary founders. We provide strategic guidance, operational expertise, and long-term partnership to empower entrepreneurs.",
    highlight: "Founder Empowerment",
    themeColor: "#ec4899"
  },
  {
    icon: <FaChess />,
    title: "Strategic Business Support",
    description: "From business planning and financial guidance to legal, administrative, branding, and technology support, we provide comprehensive growth solutions.",
    highlight: "360° Growth Support",
    themeColor: "#00afe9"
  },
  {
    icon: <FaUserTie />,
    title: "Professional Management",
    description: "Our experienced leadership team follows modern management practices, ensuring operational excellence, corporate governance, and effective decision-making.",
    highlight: "Modern Leadership",
    themeColor: "#ec4899"
  },
  {
    icon: <FaShieldAlt />,
    title: "Transparency & Governance",
    description: "We are committed to conducting business with honesty, accountability, and transparency while maintaining strong ethical business practices.",
    highlight: "Ethical Integrity",
    themeColor: "#00afe9"
  },
  {
    icon: <FaLightbulb />,
    title: "Innovation & Technology",
    description: "We embrace digital transformation and innovative technologies to improve efficiency, enhance customer experiences, and build future-ready businesses.",
    highlight: "Future-Ready Solutions",
    themeColor: "#ec4899"
  },
  {
    icon: <FaChartLine />,
    title: "Sustainable Growth",
    description: "Our focus is not only on business expansion but also on building sustainable enterprises that create long-term value for customers, partners, and society.",
    highlight: "Long-term Value Creation",
    themeColor: "#00afe9"
  },
  {
    icon: <FaHandshake />,
    title: "Strong Partnership Philosophy",
    description: "Success is achieved through collaboration. Combining entrepreneurial passion with strategic support creates partnerships built on trust and mutual growth.",
    highlight: "Collaborative Growth",
    themeColor: "#ec4899"
  },
  {
    icon: <FaGlobeAsia />,
    title: "Long-Term Global Vision",
    description: "Every decision is guided by a long-term vision of building internationally respected businesses that deliver lasting impact across Bangladesh and beyond.",
    highlight: "Global Impact",
    themeColor: "#00afe9"
  }
];

// ২. কেন ব্যবসায়ীরা IUG বেছে নেয় (১২টি কী পয়েন্ট)
const whyBusinessesChooseList = [
  "Diversified Business Platform",
  "Strategic Business Support",
  "Professional Management",
  "Strong Corporate Governance",
  "Shared Resources & Infrastructure",
  "Innovation & Technology-Driven Solutions",
  "Entrepreneur Empowerment",
  "Sustainable Business Growth",
  "Transparent Partnership Model",
  "Commitment to Quality & Excellence",
  "Long-Term Business Relationships",
  "Contribution to Economic & Social Development"
];

// ৩. শর্ট প্রেজেন্টেশন ভার্সন (১০টি পয়েন্ট)
const presentationShortList = [
  "Diversified Business Platform",
  "Entrepreneur-Focused Partnership Model",
  "Strategic Investment & Business Support",
  "Professional Leadership & Governance",
  "Shared Resources & Operational Excellence",
  "Innovation & Technology-Driven Solutions",
  "Transparent & Ethical Business Practices",
  "Sustainable Growth & Long-Term Vision",
  "Employment Generation & Social Impact",
  "Trusted Partner for Business Success"
];

const WhyChooseUs = () => {


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      {/* Banner */}
      <AboutBanner
        text={"Why Choose Us"}
        des={"We combine strategic thinking, technical innovation, and dedicated support to help your business thrive and achieve sustainable long-term success."}
      />

      <div style={{ background: "#ffffff", marginTop: "-50px" }}>


        {/* ----------------- WHY CHOOSE US CONTENT SECTION ----------------- */}
        <div style={{ maxWidth: '1440px', margin: '0 auto', padding: isMobile ? "30px 15px" : ' 80px 20px' }}>

          {/* 1. Intro Section with Image */}
          <section style={{
            display: 'flex',
            alignItems: 'center',
            gap: '40px',
            marginBottom: '70px',
            flexWrap: 'wrap'
          }}>
            <div style={{ flex: '1 1 500px' }}>
              <span style={{
                display: 'inline-block',
                padding: '6px 18px',
                backgroundColor: '#e0f2fe',
                color: '#00afe9',
                fontSize: '0.875rem',
                fontWeight: '700',
                borderRadius: '50px',
                marginBottom: '16px',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}>
                Building Trust. Creating Value.
              </span>

              <h2 style={{
                fontSize: '2.25rem',
                fontWeight: '800',
                color: '#0f172a',
                marginBottom: '16px',
                lineHeight: '1.25'
              }}>
                More Than a Business Group Your Trusted Growth Partner
              </h2>

              <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: '1.8', margin: '0 0 20px 0' }}>
                At <strong>Iconic Unity Group (IUG)</strong>, we are a trusted business platform committed to empowering entrepreneurs, supporting sustainable ventures, and delivering long-term value through innovation, collaboration, and professional excellence.
              </p>

              <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: '1.8', margin: 0 }}>
                Choosing IUG means partnering with a dedicated team that believes in building businesses with purpose, integrity, and a shared vision for global success.
              </p>
            </div>

            <div style={{ flex: '1 1 400px' }}>
              <img
                src="https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=800&q=80"
                alt="Iconic Unity Group Partnership"
                style={{
                  width: '100%',
                  height: '360px',
                  objectFit: 'cover',
                  borderRadius: '16px',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.06)'
                }}
              />
            </div>
          </section>

          {/* 2. Core Reasons Cards Grid */}
          <section style={{ marginBottom: '70px', }}>
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <h3 style={{ fontSize: isMobile ? "1.4rem" : '2rem', fontWeight: '800', color: '#0f172a', margin: '0 0 10px 0', textTransform: "uppercase", }}>
                Our Core Pillars & Values
              </h3>
              <p style={{ fontSize: '1rem', color: '#64748b', margin: 0 }}>
                Discover the core advantages that set us apart as an industry leader.
              </p>
            </div>

            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '24px',

            }}>
              {whyChooseUsData.map((item, index) => (
                <div
                  key={index}
                  style={{
                    flex: '1 1 calc(33.333% - 24px)',
                    minWidth: '280px',
                    // maxWidth: '380px',
                    backgroundColor: '#ffffff',
                    padding: '32px 24px',
                    borderRadius: '16px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.03)',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    boxSizing: 'border-box'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-6px)';
                    e.currentTarget.style.borderColor = item.themeColor;
                    e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.08)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.03)';
                  }}
                >
                  <div>
                    <div style={{
                      width: '40px',
                      height: '4px',
                      backgroundColor: item.themeColor,
                      borderRadius: '2px',
                      marginBottom: '20px'
                    }} />

                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                      <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '12px',
                        backgroundColor: item.themeColor === '#00afe9' ? '#e0f2fe' : '#fce7f3',
                        color: item.themeColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '20px',
                        flexShrink: 0
                      }}>
                        {item.icon}
                      </div>
                      <h4 style={{ fontSize: '1.2rem', fontWeight: '700', color: '#0f172a', margin: 0, lineHeight: '1.3' }}>
                        {item.title}
                      </h4>
                    </div>

                    <p style={{ fontSize: '0.95rem', color: '#475569', lineHeight: '1.65', marginBottom: '20px' }}>
                      {item.description}
                    </p>
                  </div>

                  <div style={{
                    padding: '10px 14px',
                    backgroundColor: '#f8fafc',
                    borderRadius: '8px',
                    borderLeft: `3px solid ${item.themeColor}`
                  }}>
                    <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: '600', color: '#334155' }}>
                      <span style={{ color: item.themeColor, fontWeight: '700' }}>Advantage: </span>
                      {item.highlight}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* 3. Why Businesses Choose IUG & Presentation Version */}
          <section style={{
            display: 'flex',
            gap: '32px',
            flexWrap: 'wrap',
            marginBottom: '70px'
          }}>
            {/* Left Card: Why Businesses Choose IUG */}
            <div style={{
              flex: '1 1 500px',
              backgroundColor: '#ffffff',
              padding: '36px 28px',
              borderRadius: '16px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.02)'
            }}>
              <h3 style={{ fontSize: '1.5rem', fontWeight: '800', color: '#0f172a', marginBottom: '20px' }}>
                Why Businesses Choose IUG
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))', gap: '14px' }}>
                {whyBusinessesChooseList.map((text, idx) => (
                  <div key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <FaCheckCircle style={{ color: '#00afe9', marginTop: '3px', flexShrink: 0 }} />
                    <span style={{ fontSize: '0.95rem', color: '#334155', fontWeight: '500', lineHeight: '1.5' }}>
                      {text}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Card: Presentation Version (Short) */}
            <div style={{
              flex: '1 1 400px',
              backgroundColor: '#f0f9ff',
              padding: '36px 28px',
              borderRadius: '16px',
              border: '1px solid #bae6fd',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.02)'
            }}>
              <span style={{
                fontSize: '0.75rem',
                fontWeight: '800',
                color: '#00afe9',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                display: 'block',
                marginBottom: '8px'
              }}>
                Presentation Version (Short)
              </span>
              <h3 style={{ fontSize: '1.5rem', fontWeight: '800', color: '#0369a1', marginBottom: '20px' }}>
                Why Choose Iconic Unity Group?
              </h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {presentationShortList.map((item, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FaCheckCircle style={{ color: '#0284c7', flexShrink: 0 }} />
                    <span style={{ fontSize: '0.95rem', color: '#0c4a6e', fontWeight: '600' }}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          {/* 4. Commitment Quote Banner */}
          <section
            style={{
              maxWidth: "1440px",
              margin: "0px auto",
              padding: isMobile ? "0px 0px" : "0px 60px",
              textAlign: "center",
            }}
          >
            <span
              style={{
                display: "inline-block",
                color: "#000000",
                fontSize: isMobile ? "1.6rem" : "2rem",
                fontWeight: "700",
                letterSpacing: "2px",
                paddingBottom: isMobile ? "20px" : "",
                textTransform: "uppercase",


              }}
            >
              Our Commitment
            </span>

            <blockquote
              style={{
                fontSize: "1.35rem",
                fontWeight: "500",
                lineHeight: "1.9",
                color: "#334155",
                margin: "0",

              }}
            >
              “At <strong>Iconic Unity Group</strong>, we don't just build companies we
              build partnerships, empower entrepreneurs, and create sustainable
              businesses that deliver lasting value for generations.”
            </blockquote>
          </section>

        </div>
        {/* ----------------- END OF CONTENT SECTION ----------------- */}

        <WhyChooseUsSection></WhyChooseUsSection>

        {/* Other Page Components */}
        <Achievements />
        <SisterConcerms />
      </div>
    </div>
  );
};

export default WhyChooseUs;